// EventFields — Presentational dispatcher that selects the per-type field group
// by `eventType`, wrapped in the source's "Form" container (the
// `<div style={{ marginBottom: '24px' }}>`). It renders FlightFields,
// HotelFields, CarFields, or DiningFields for the matching type and renders the
// wrapper with NO field group for any unknown/missing type — exactly mirroring
// the source, where the four `eventType === '...' && render...()` guards all
// evaluate to false and the form container renders empty.
//
// Extracted verbatim from `AddEventForm.js` (the "Form" block) as part of the
// behavior-preserving refactor (issue #240). The `formData`, `errors`, and
// `onChange` props are forwarded unchanged to the selected group so the inputs
// stay fully controlled. Render-only, wrapped in React.memo, with NO internal
// state. The wrapper markup, the conditional guards, and the type ordering are
// identical to the source.
//
// Props:
//   eventType - string; selects which field group renders (none if unknown)
//   formData  - object; the controlled field values, forwarded to the group
//   errors    - object; per-field validation errors, forwarded to the group
//   onChange  - (field, value) => void, forwarded to the group
//
// Validates: Requirements 3.3, 3.4, 1.2, 1.6

import React from 'react';
import { FlightFields } from './FlightFields';
import { HotelFields } from './HotelFields';
import { CarFields } from './CarFields';
import { DiningFields } from './DiningFields';

export const EventFields = React.memo(function EventFields({
  eventType,
  formData,
  errors,
  onChange
}) {
  return (
    <div style={{ marginBottom: '24px' }}>
      {eventType === 'flight' && (
        <FlightFields formData={formData} errors={errors} onChange={onChange} />
      )}
      {eventType === 'hotel' && (
        <HotelFields formData={formData} errors={errors} onChange={onChange} />
      )}
      {eventType === 'car' && (
        <CarFields formData={formData} errors={errors} onChange={onChange} />
      )}
      {eventType === 'dining' && (
        <DiningFields formData={formData} errors={errors} onChange={onChange} />
      )}
    </div>
  );
});

export default EventFields;
